import axiosClient from "./axiosClient";
// import { ApiResponse } from "models";
import { StatementPayload } from "models/statement";

const statementApi = {
  getStatementList(data: StatementPayload): Promise<any> {
    const url = `/statement/generateStatement?page=${data.page || ""}&limit=${
      data.limit || ""
    }&search=${data.search || ""}&region=${data.region || ""}&sortField=${
      data.sortName || ""
    }&sortType=${data.sortType || ""}
    `;
    return axiosClient.post(url, {
      brandId: data.brandId,
      periodStart: data.periodStart,
      periodEnd: data.periodEnd,
      ...(data.status && { filter: { status: data.status } }),
    });
  },
};

export default statementApi;
